import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
// import { Authenticator } from 'services/AuthService.jsx';
import { DataAPI } from 'services/DataService.jsx';

import * as Datetime from 'react-datetime';

import $ from 'jquery';

import Log from 'services/Log.jsx'



require('datatables.net-responsive');
$.DataTable = require('datatables.net-bs');
// var DatePicker = require("react-bootstrap-date-picker");
var dateFormat = require('dateformat');

const dataTable = {
    headerRow: [ 'Name', 'Active' ],
    footerRow: [ 'Name', 'Active' ],
    dataRows: []
};

let startDate = new Date() - 24*3600*1000;
let endDate = new Date();

class Clients extends Component{

  constructor(props){
    super(props);
    this.state = {
      selected_project : {
        owner: {}
      }
    };
  }

  setupTable() {
      $("#datatables").DataTable({
          "pagingType": "full_numbers",
          "lengthMenu": [[10, 25, 50, -1], [10, 25, 50, "All"]],
          responsive: true,
          language: {
              search: "_INPUT_",
              searchPlaceholder: "Filter clients",
          }
      });

      var table = $('#datatables').DataTable();
      table.clear().rows.add(dataTable.dataRows).draw();

      // // Edit record
      // table.on( 'click', '.edit', function () {
      //     var $tr = $(this).closest('tr');
      //
      //     var data = table.row($tr).data();
      //     alert( 'You press on Row: ' + data[0] + ' ' + data[1] + ' ' + data[2] + '\'s row.' );
      // } );
      //
      // // Delete a record
      // table.on( 'click', '.remove', function (e) {
      //     var $tr = $(this).closest('tr');
      //     table.row($tr).remove().draw();
      //     e.preventDefault();
      // } );
      //
      // //Like record
      // table.on( 'click', '.like', function () {
      //     alert('You clicked on Like button');
      // });
  }
  componentDidMount(props) {
    Log.debug('mounting');
      this.setupTable();
  }
  loadData() {
      var formatedStartDate = dateFormat(startDate, "yyyy-mm-dd HH:MM:ss") + ".000";
      var formatedEndDate = dateFormat(endDate, "yyyy-mm-dd HH:MM:ss") + ".000";
      Log.debug("[loadDate] " + formatedStartDate);
      DataAPI.getClients({
          start_date: formatedStartDate,
          end_date: formatedEndDate
      }, (response) => {
          Log.debug(JSON.stringify(response));
          var table = $("#datatables").DataTable();
          if (response.success) {
              dataTable.dataRows = [];
              response.data.clients.forEach((client) => {
                var row = "";
                var cDate = new Date(client.date);
                var currentDate = new Date();
                var diff = (currentDate - cDate) / 1000;
                if (diff < 15*60) {
                  row = '<div class="text-success"><span class="glyphicon glyphicon-ok-sign"></span></div>';
                } else if (diff < 4*60*60) {
                  row = '<div class="text-warning"><span class="glyphicon glyphicon-minus-sign"></span></div>';
                } else {
                  row = '<div class="text-danger"><span class="glyphicon glyphicon-minus-sign"></span></div>';
                }
                Log.debug(row);
                dataTable.dataRows.push([client.name, row]);
              });
              // Log.debug(client_names);
              // dataTable.dataRows.push([client_names]);
              Log.debug(JSON.stringify(dataTable));
              table.clear().rows.add(dataTable.dataRows).draw();
          } else {
              table.clear().draw();
          }
      });
  }
  handleStartDate(e) {
      startDate = e.toDate();
  }
    handleEndDate(e) {
        endDate = e.toDate();
    }
    componentWillUnmount(){
        $('.data-table-wrapper')
            .find('table')
            .DataTable()
            .destroy(true);
    }
    shouldComponentUpdate() {
        return false;
    }

    render(){
      Log.debug("[Clients] data: " + JSON.stringify(dataTable));
        return (
            <div className="main-content">
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title="Clients"
                                content={
                                    <div className="fresh-datatables">
                                        <Row>
                                          <Col md={4} className="date-picker-wrapper">
                                              <span className="date-label">From: </span>
                                              <Datetime defaultValue={startDate} onChange={this.handleStartDate}/>
                                          </Col>
                                          <Col md={4} className="date-picker-wrapper">
                                              <span className="date-label">To: </span>
                                              <Datetime defaultValue={endDate} onChange={this.handleEndDate}/>
                                          </Col>
                                          <Col md={4} className="date-picker-wrapper">
                                            <div className="btn btn-success btn-fill client-search-btn" onClick={this.loadData}>Query</div>
                                          </Col>
                                        </Row>
                                        <table id="datatables" ref="main" className="table table-striped table-no-bordered table-hover" cellSpacing="0" width="100%" style={{width:"100%"}}>
                                            <thead>
                                                <tr>
                                                    <th>{ dataTable.headerRow[0] }</th>
                                                    <th>{ dataTable.headerRow[1] }</th>
                                                </tr>
                                            </thead>
                                            <tfoot>
                                                <tr>
                                                    <th>{ dataTable.footerRow[0] }</th>
                                                    <th>{ dataTable.footerRow[1] }</th>
                                                </tr>
                                            </tfoot>
                                            <tbody>
                                            {
                                                dataTable.dataRows.map((prop,key) => {
                                                    return (
                                                        <tr key={key}>
                                                          <td  key={key + "_td_1"}>{prop[0]}</td>
                                                          <td  key={key + "_td_2"}>{prop[1]}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

export default Clients;



// WEBPACK FOOTER //
// ./src/views/Clients/Clients.jsx